import { store } from '@/state/store';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__words_vocabulary } from '@shared/dto/+word/word_translated/DTO__words_vocabulary';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

export function translate_word(word: DTO__word) {
  let { user_settings } = store.getState().slice_user;

  //we rely on i18n because user could be unauthorized
  let vocabulary = store.getState().slice_words.words_vocabularies.get(user_settings.regional_language) || DTO__words_vocabulary.CREATE_STUB();

  let out = vocabulary.words_map.get(word.word_english);

  if (out) {
    out = out.clone();
  } else {
    out = new DTO__word();
    out.word_english = word.word_english;
    out.word_translated = word.word_english;
    out.language = ENUM__language_type.ENGLISH;
  }

  return out;
}
